
/* homee */
export const GET_HOME_DATA = "GET_HOME_DATA";
export const GET_HOME_DATA_SUCCESS ="GET_HOME_DATA_SUCCESS";
export const GET_HOME_DATA_FAIL = "GET_HOME_DATA_FAIL";
